import React from 'react';
import { Link } from 'react-router-dom';

const HomePostCard = ({ post }) => {
  return (
    <Link to={`/posts/${post.id}`} className='link'>
      <div className='row mb-5'>
        <div className='col-sm-8 home-post-pic-container mb-2'>
          <img className='home-post-pic' src={post.cover_image_url} alt='home-post-pic' />
        </div>
        <div className='col-sm'>
          <p className='mb-2'>{post.date}</p>
          <h2 className='mb-2'>{post.title}</h2>
        </div>
      </div>
    </Link>
  );
};

export default HomePostCard;
